import { render } from "./BookTakeBack.vue?vue&type=template&id=f57c5a98&scoped=true"
import script from "./BookTakeBack.vue?vue&type=script&lang=js"
export * from "./BookTakeBack.vue?vue&type=script&lang=js"

import "./BookTakeBack.vue?vue&type=style&index=0&id=f57c5a98&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f57c5a98"]])

export default __exports__